export const tenantEndpoints = {
  GetById: 'api/Tenant/',
  GetTenantDropDownList: 'api/Tenant/DropDown',
  GetTenantModule: 'api/TenantModule/GetByTenantId/',
  GetTenantTypes: 'api/TenantTaskType/GetAllByTenantId',
  getTenantList: '/api/Tenant/TenantList',
  getTenantStatus: '/api/Tenant/Status',
  getTenantsAllAssigned: '/api/Tenant/GetAllAssigned',
  getClientFilter: '/api/Client/Filter',
  getTenantDetailsById: '/api/Tenant/TenantDetail',
  getTenantDashboards: '/api/Dashboard/GetTenantDashboard',
  getTenantDetails: '/api/Tenant',
  getTenantFiles: '/api/TenantFolder/Filter',
  createTenantFolder: '/api/TenantFolder/Insert',
  deleteTenantFolder: '/api/TenantFiles/Delete',
  createTenantFile: '/api/TenantFiles/Insert',

  getTenantFolderMembersByFolderId: '/api/TenantFolderUser/GetFolderMembers',
  getTenantSubFolders: '/api/TenantFolder/GetByFolderId',

  getTenantChartForTeam: '/api/Tenant/GetTenantChartForTeam',
  getAllTaskAndSubTask: '/api/Task/GetAllTaskAndSubTaskBySP',

  createTenant: '/api/Tenant/Insert',
  getTenantNotes: '/api/TenantNotes/GetByTenantId',
  createTenantNotes: '/api/TenantNotes/Insert',

  getIssueList: '/api/Issue/Filter',
  createTenantIssue: '/api/Issue/Insert',

  issueFileUpload: 'api/IssueFile/Upload',
  issueFileDelete: 'api/IssueFile/Delete',

  getIssueDetails: '/api/Issue',

  changeIssueStatus: '/api/Issue/ChangeStatus',

  deleteIssue: '/api/Issue/Delete',
  deleteNote: '/api/TenantNotes/Delete',

  updateTenant: '/api/Tenant/Update',

  updateTenantStatus: '/api/Tenant/ChangeStatus',

  archiveTenant: '/api/Tenant/Archive',
  getMilestone: '/api/MileStone/Filter',
  getMilestoneTasks: '/api/Task/GetAllBySP',

  createMilestone: '/api/MileStone/Insert',
  deleteMilestone: '/api/MileStone/Delete',
  getMilestoneDetails: '/api/MileStone',
  removeMiletoneTask: '/api/MileStone/TaskBindWithMileStone',
};

// ./utils/api-endpoints/employee-files.ts

export const tenanFolderFileEndpoints: Record<string, string> = {
  getTenantFilesByFilter: '/api/TenantFolder/Filter',
  getTenantFolderByTenantId: '/api/TenantFolder/GetByTenantId',

  getTenantFolderByFolderId: '/api/TenantFolder/GetByFolderId',

  getTenantFolderMembersByFolderId: '/api/TenantFolderUser/GetFolderMembers',

  createTenantFolder: '/api/TenantFolder/Insert',
  updateTenantFolder: '/api/TenantFolder/Update',
  updateTenantFolderShare: '/api/TenantFolder/Share',
  deleteTenantFolder: '/api/TenantFolder/Delete',

  uploadTenantFile: '/api/TenantFiles/Upload',
  createTenantFile: '/api/TenantFiles/Insert',
  deleteTenantFile: '/api/TenantFiles/Delete',
  updateTenantFile: '/api/TenantFiles/Update',
  //
  shareTenantFile: '/api/TenantFolder/Share',

  editTenantFolder: '/api/TenantFolder/Update',
  editProjectFolder: '/api/ProjectFolder/Update',

  editClientFolder: '/api/ClientFolder/Update',
};
